import React, { Component } from 'react';
import { componentType } from '../WorkflowEditor';

export class HTMLDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formContent: {
                title: "",
                isRequired: false,
                type: "",
                name: '',
                notice: '',
                placeHolder: '',
                id: '',
                errorMessage: '',
                dropdownval: [],
                options: [],
                validations: [],
                displaytype: 'horizontal'
            },
        }
    };

    setProperties = (properties) => {
        const { title, isRequired, type, name, notice, placeHolder, id, errorMessage, options, validations, value, displaytype } = properties;
        const { formContent } = this.state;
        formContent.title = title;
        formContent.value = value;
        formContent.isRequired = isRequired;
        formContent.type = type;
        formContent.name = name;
        formContent.notice = notice;
        formContent.placeHolder = placeHolder;
        formContent.id = id;
        formContent.errorMessage = errorMessage;
        formContent.options = options;
        formContent.validations = validations;
        formContent.displaytype = displaytype;
        this.setState({
            formContent
        });
    };

    handleChangeFormContent = (e) => {
        const { value, name } = e.target;
        const { formContent } = this.state;
        formContent[name] = value;
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    };

    handleOptionChange = (e, index) => {
        const { value, name } = e.target;
        const { formContent } = this.state;
        formContent.options[index][name] = value;
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    };

    onClickRemoveFormData = (index, e) => {
        e.preventDefault();
        const { formContent } = this.state;
        formContent.options.splice(index, 1);
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    }

    handleoptioanschecked = (index, e) => {
        const { formContent } = this.state;
        formContent.options[index].isChecked = e.target.checked;
        for (let i = 0; i < formContent.options.length; i++) {
            if (i == index) {
                if (e.target.checked) {
                    formContent.value.push(formContent.options[i].value);
                } else {
                    for (let j = 0; j < formContent.value.length; j++) {
                        if (formContent.options[i].value === formContent.value[j]) {
                            formContent.value.splice(j, 1);
                        }
                    }
                }
            }
        }
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    }

    onChangeradioState = (index, e) => {
        const { formContent } = this.state;
        formContent.options[index].isChecked = e.target.checked;
        let radioval = [];
        formContent.options[index].isChecked = e.target.checked;
        radioval.push(formContent.options[index].value);
        this.setState({
            formContent
        })
        this.props.onChangeContent(formContent);
    }

    renderValidations = () => {
        const { formContent } = this.state;
        let retData = [];
        for (let i = 0; i < formContent.validations.length; i++) {
            let row = formContent.validations[i];
            retData.push(
                <div key={`validations-${i}`} className="d-block display-type-box">
                    <div className="d-inline-block w-25 align-top pr-1">
                        <div className="form-group">
                            <label htmlFor="Value" className="d-block w-100 text-center">Value</label>
                            <input type="text" className="form-control" name="regularexpression" value={row.regEx} onChange={(e) => this.handleChangeValidationContent(e, i)} />
                        </div>
                    </div>
                    <div className="d-inline-block w-75 align-top pl-1">
                        <div className="form-group">
                            <label htmlFor="Text" className="d-block w-100 text-left">Text <button className="btn float-right"><i className="fa fa-times" onClick={e => this.onClickRemoveValidationData(i, e)}></i></button></label>
                            <input type="text" className="form-control" name="errormessage" value={row.message} onChange={(e) => this.handleChangeValidationContent(e, i)} />
                        </div>
                    </div>
                </div>
            );
        }
        return retData;
    }

    renderOptions = () => {
        const { formContent } = this.state;
        let retData = [];
        for (let i = 0; i < formContent.options.length; i++) {
            let row = formContent.options[i];
            retData.push(
                <div key={`options-${i}`} className="d-block display-type-box">
                    <div className="d-inline-block w-25 align-top pr-1">
                        <div className="form-group">
                            <label htmlFor="Value" className="d-block w-100 text-center">Value</label>
                            <input type="text" className="form-control" name="value" value={row.value} onChange={(e) => this.handleOptionChange(e, i)} />
                            {(row.isChecked && formContent.type === componentType.CHECK_BOX) &&
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" checked={row.isChecked} onChange={(e) => this.handleoptioanschecked(i, e)} />
                                </div>
                            }
                            {formContent.type === componentType.RADIO &&
                                <div className="form-check">
                                    <input type="radio" name='radiodata-props' checked={formContent.value.indexOf(row.value) !== -1} onChange={(e) => this.onChangeradioState(i, e)} className="form-check-input" />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="d-inline-block w-75 align-top pl-1">
                        <div className="form-group">
                            <label htmlFor="Text" className="d-block w-100 text-left">Text <button className="btn float-right"><i className="fa fa-times" onClick={e => this.onClickRemoveFormData(i, e)}></i></button></label>
                            <input type="text" className="form-control" name="label" value={row.label} onChange={(e) => this.handleOptionChange(e, i)} />
                        </div>
                    </div>
                </div>
            );
        }
        return retData;
    }

    addNewOption = () => {
        const { formContent } = this.state;
        formContent.options.push({ label: `Item ${formContent.options.length + 1}`, value: formContent.options.length + 1, isChecked: false });
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    }

    addNewValidationData = () => {
        const { formContent } = this.state;
        formContent.validations.push({ regEx: '', message: '' });
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    }

    handleChangeValidationContent = (e, index) => {
        const { value, name } = e.target;
        const { formContent } = this.state;
        for (let i = 0; i < formContent.validations.length; i++) {
            if (i === index && name === 'regularexpression') {
                formContent.validations[i].regEx = value;
            } else if (i === index && name === 'errormessage') {
                formContent.validations[i].message = value;
            }
        }
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    }

    onClickRemoveValidationData = (index, e) => {
        e.preventDefault();
        const { formContent } = this.state;
        formContent.validations.splice(index, 1);
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    }

    setRequiredProperty = (e) => {
        const { formContent } = this.state;
        formContent.isRequired = e.target.checked;
        this.setState({
            formContent,
        });
        this.props.onChangeContent(formContent);
    }

    getComponentName = () => {
        const { formContent } = this.state;
        if (formContent.type === componentType.TEXT) {
            return "Single Input"
        } else if (formContent.type === componentType.RADIO) {
            return "Radio Group"
        } else if (formContent.type === componentType.SELECTBOX) {
            return "Drop Down"
        } else if (formContent.type === componentType.CHECK_BOX) {
            return "Checkbox"
        } else if (formContent.type === componentType.FILE) {
            return "Upload File"
        } else if (formContent.type === componentType.DATE) {
            return "Type Date"
        } else if (formContent.type === componentType.TEXT_AREA) {
            return "Text Area"
        }
        return "";
    };

    setDisplayType = (type) => {
        const { formContent } = this.state;
        formContent['displaytype'] = type;
        this.setState({
            formContent
        });
        this.props.onChangeContent(formContent);
    }

    render() {
        const { formContent } = this.state;
        return (
            <>
                {
                    (formContent.type === componentType.TEXT || formContent.type === componentType.RADIO || formContent.type === componentType.SELECTBOX || formContent.type === componentType.CHECK_BOX || formContent.type === componentType.FILE || formContent.type === componentType.DATE || formContent.type === componentType.TEXT_AREA) &&
                    <div className="d-block title">{this.getComponentName()}</div>
                }
                <div className="form-group">
                    <label htmlFor="Title">Title</label>
                    <input type="text" className="form-control" id="Title" value={formContent["title"]} onChange={this.handleChangeFormContent} name="title" placeholder="First Name" />
                </div>
                <div className="form-group">
                    <label htmlFor="Title">Name</label>
                    <input type="text" className="form-control" id="Name" name="name" value={formContent["name"]} onChange={this.handleChangeFormContent} placeholder="Input Name" />
                </div>
                <div className="form-group">
                    <label htmlFor="Value">Value</label>
                    <input type="text" className="form-control" id="Value" name="value" value={formContent["value"]} onChange={this.handleChangeFormContent} placeholder="Input Value" />
                </div>
                <div className="form-group">
                    <label htmlFor="Title">Id</label>
                    <input type="text" className="form-control" id="Id" name="id" value={formContent["id"]} onChange={this.handleChangeFormContent} placeholder="Input Id" />
                </div>
                <div className="form-group">
                    <label htmlFor="notice">Notice</label>
                    <textarea className="form-control" id="notice" name="notice" value={formContent["notice"]} onChange={this.handleChangeFormContent} placeholder="Enter the notice"></textarea>
                </div>
                {
                    (formContent.type === componentType.TEXT || formContent.type === componentType.TEXT_AREA) &&
                    <div className="form-group">
                        <label htmlFor="placeHolder">Placeholder</label>
                        <input type="text" className="form-control" id="placeHolder" name="placeHolder" value={formContent["placeHolder"]} onChange={this.handleChangeFormContent} placeholder="Enter the name" />
                    </div>
                }
                {
                    formContent.isRequired != undefined &&
                    <div className="form-group form-check">
                        <input type="checkbox" checked={formContent.isRequired} onChange={this.setRequiredProperty} className="form-check-input" />
                        <label className="form-check-label">Is required</label>
                    </div>
                }
                {
                    formContent.isRequired &&
                    <div className="form-group">
                        <label htmlFor="errorMessage">Required message</label>
                        <textarea className="form-control" id="errorMessage" name="errorMessage" value={formContent["errorMessage"]} onChange={this.handleChangeFormContent} placeholder="Enter required message."></textarea>
                    </div>
                }
                <div className="form-group">
                    <label htmlFor="displayType">Display Type</label>
                    <ul className="display-type-tab">
                        <li onClick={() => this.setDisplayType('horizontal')} className={formContent['displaytype'] == "horizontal" ? "active" : ''}>Horizontal</li>
                        <li onClick={() => this.setDisplayType('vertical')} className={formContent['displaytype'] == "vertical" ? "active" : ''}>Vertical</li>
                    </ul>
                </div>
                {formContent.validations &&
                    <>
                        {this.renderValidations()}
                        <button className="btn btn-primary mt-2 btn-add-new" onClick={this.addNewValidationData}>+ Add New</button>
                    </>
                }
                {(formContent.type === componentType.RADIO || formContent.type === componentType.CHECK_BOX || formContent.type === componentType.SELECTBOX) &&
                    <>
                        {this.renderOptions()}
                        <button className="btn btn-primary mt-2 btn-add-new" onClick={this.addNewOption}>+ Add New</button>
                    </>
                }
            </>
        );
    }
}